import * as React from "react";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { DeveloperRoutes } from "src/common/developers";
import { Icon } from "src/components";

type AllProps = {
  active_path?: string;
}

function WorkflowNavigationComponent(props: AllProps) {
  const { active_path } = props;

  return (
    <Nav>
      <Link title="Info"
        className={`nav-link${active_path === DeveloperRoutes.info_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.workflow_route}/${DeveloperRoutes.info_route}`}
      >
        <Icon className="ficon-info" />
        <span>Info</span>
      </Link>
      <Link title="Create User"
        className={`nav-link${active_path === DeveloperRoutes.create_user_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.workflow_route}/${DeveloperRoutes.create_user_route}`} 
      >
        <Icon className="ficon-user" />
        <span>Create User</span>
      </Link>
      <Link title="Organization"
        className={`nav-link${active_path === DeveloperRoutes.organization_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.workflow_route}/${DeveloperRoutes.organization_route}`}
      >
        <Icon className="ficon-monitor" />
        <span>Organization</span>
      </Link>
    </Nav>
  );
}

export default React.memo(WorkflowNavigationComponent);
